import React from "react"
import { connect } from "react-redux"
import { useEffect, useState } from "react"
import Clients from "./Clients"
import { getEntities } from "../../../redux/reducers/entity/entity-reducer"


const mapStateToProps = (state) => {

    return {
        clients: state.entity.items
    }
}

const ClientsContainer = (props) => {




    const [clients, setClients] = useState(null)


    useEffect(() => {
        if (!clients) {
            setClients(props.clients)
        }

    }, [props.clients])

    useEffect(() => {
        debugger
        props.getEntities('clients')

    }, [])

    //todo передать в Client готового клиента или пустого или существующего , сделать все запросы и всю грязь
    return (

        clients && <Clients clients={clients} />


    )
}


export default connect(mapStateToProps, {
    getEntities
})(ClientsContainer)